import { Bold, BoldDaDeHuSv, BoldEs, BoldFrIt, BoldRu, BoldTr, HelpButton, HelpButtonToolbar, Italic, ItalicDaDeEsSv, ItalicHu, ItalicIt, ItalicRu, ItalicTr, Underline, UnderlineEsFrIt, UnderlineHu, UnderlineRu, UnderlineUk } from '@sas/react-svg';
// This list of icons should match the list of icons with locale overrides in the descriptor.json file.
// https://gitlab.sas.com/novacommons/nova-svg/-/blob/master/src/assets/descriptor.json
const LocalizedSVGs = {
  HelpButton,
  HelpButtonToolbar,
  Bold,
  BoldDaDeHuSv,
  BoldEs,
  BoldFrIt,
  BoldRu,
  BoldTr,
  Underline,
  UnderlineEsFrIt,
  UnderlineHu,
  UnderlineRu,
  UnderlineUk,
  Italic,
  ItalicDaDeEsSv,
  ItalicHu,
  ItalicIt,
  ItalicRu,
  ItalicTr
};

/**
 * Returns the localized version of an SVG.
 *
 * @param name name of a localized SVG
 */
export const findLocalizedSVG = name => {
  return LocalizedSVGs[name];
};
//# sourceMappingURL=findLocalizedSVG.js.map